// extracted by mini-css-extract-plugin
export default {"main":"Cookie_main__RmEoU","content":"Cookie_content__Oa3qp"};